import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createywkzgrq4l4xy as create } from '../../../../../../kotlin-react/react/create.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function component1(_this__u8e3s4) {
  return _this__u8e3s4.state;
}
function create_0(_this__u8e3s4, state, key) {
  key = key === VOID ? null : key;
  return create(_this__u8e3s4, ($this$create) => {
    $this$create.state = state;
    var tmp0_safe_receiver = key;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$create.key = tmp0_safe_receiver;
    }
    return Unit_instance;
  });
}
//region block: exports
export {
  component1 as component12goe0t36bs1uq,
  create_0 as create3ikxgp8wi1rdg,
};
//endregion

//# sourceMappingURL=LoadingPageFramePropsExtentions.mjs.map
